import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './FieldInput.scss'

import ClipboardButton from 'react-clipboard.js'

class FieldInput extends React.Component {
	constructor() {
		super()
		this.state = {
			copySuccess: false,
			copyError: false
		}
	}
	render() {
		const { fieldId, error, tooltip, highlighted, ...rest } = this.props
		return (
			<span styleName="wrapper">
				{tooltip ? tooltip : null}
				<input
					{...rest}
					id={fieldId}
					styleName={error ? 'input-error' : 'input'}
				/>
				{rest.readOnly ? (
					<span styleName="copy-button-wrapper">
						<ClipboardButton
							styleName="copy-button"
							component="a"
							button-href="#"
							button-onClick={e => e.preventDefault()}
							data-clipboard-text={rest.value}
							onSuccess={() => {
								this.setState({ copySuccess: true })
								let reset = setTimeout(() => {
									this.setState({ copySuccess: false })
								}, 1500)
							}}
							onError={() => {
								this.setState({ copyError: true })
								let reset = setTimeout(() => {
									this.setState({ copyError: false })
								}, 1500)
							}}
						>
							{this.state.copyError
								? 'Copy manually'
								: this.state.copySuccess ? 'Copied!' : 'Copy'}
						</ClipboardButton>
					</span>
				) : null}
			</span>
		)
	}
}
FieldInput.propTypes = {
	id: React.PropTypes.string,
	error: React.PropTypes.bool
}

export default CSSModules(FieldInput, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Form/FieldInput.js